import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    poll: { type: Boolean, default: false },
  }

  static targets = ["steps"]

  connect() {
    if (this.pollValue) {
      this.refresh()
      this.timer = window.setInterval(() => this.refresh(), 2000)
    }
  }

  disconnect() {
    if (this.timer) window.clearInterval(this.timer)
  }

  async refresh() {
    try {
      const response = await fetch(this.urlValue, {
        headers: { Accept: "application/json" },
        credentials: "same-origin",
      })
      if (!response.ok) return

      const data = await response.json()
      this.updateSteps(data.steps || [])

      if (data.active || data.failed) {
        window.clearInterval(this.timer)
        window.location.reload()
      }
    } catch (error) {
      console.warn("[pro-telephony-provision] poll failed", error)
    }
  }

  updateSteps(steps) {
    steps.forEach((step) => {
      const item = this.stepsTarget.querySelector(`[data-step="${step.key}"]`)
      if (!item) return

      item.dataset.state = step.state
    })
  }
}
